const passkey_sign_in = {
    setup_page: {
        title: 'Vereinfache deine Anmeldung',
        subtitle: 'Passkey erstellen',
        description: 'Registriere deinen Passkey mit Gerätebiometrie, Sicherheitsschlüsseln wie YubiKey oder anderen verfügbaren Methoden.',
    },
    trigger_conditional_ui_failed: 'Passkey-Autofill konnte nicht ausgelöst werden.',
};
export default Object.freeze(passkey_sign_in);
